import { MutationHookOptions, useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { fragments } from '@/hooks/fragments'
import { Mutation, MutationRemoveLastItemEventArgs } from '@/schemaTypes'
import { itemFragments } from './itemFragments'

const REMOVE_LAST_ITE_EVENT = gql`
  mutation removeLastItemEvent(
    $itemId: ObjectId!
    $isNeededToRemoveRelatedValorizationEntry: Boolean!
  ) {
    removeLastItemEvent(
      itemId: $itemId
      isNeededToRemoveRelatedValorizationEntry: $isNeededToRemoveRelatedValorizationEntry
    ) {
      _id
      serialNumber
      imei
      itemSpecification
      note
      policeNumber
      isDamageCase
      damageCasePeriods {
        from
        to
      }
      personalUsePeriods {
        from
        to
      }
      isForPersonalUse
      isInvestmentGold
      createdAt
      updatedAt
      ean
      storageFacilityId
      storageFacility {
        _id
        storageUnitIds
      }
      media {
        ...FileMetadataFragment
      }
      dealsHistory {
        dealId
        algoliaReference
        title
        material
        answers {
          questionId
          selectedOptionIndex
          rangeValue
        }
        questions {
          ...ItemQuestionFragment
        }
        questionIds
        itemCategoryId
        values {
          verified {
            currentMarketValue
            predictedMarketValue
            adjustedMarketValue
            loanToValue
            maxMarketValue
          }
        }
      }
      lastBookingNumber
      bookingNumbers
      piceaUploadLink {
        ...FileMetadataFragment
      }
      entrupyCertificateUrl
      checkedBy
      checkedAt
      uploadedFiles {
        ...FileMetadataFragment
      }
      storageHistory {
        storageUnits {
          lvl1
          lvl2
          lvl3
          lvl4
        }
        createdAt
        timestamp
        storageStatus
        employeeId
        note
      }
      storageLabel
      events {
        ...ItemEventFragment
      }
    }
  }
  ${fragments.fileMetadata}
  ${itemFragments.itemQuestionFragment}
  ${itemFragments.itemEvent}
`

type TData = { removeLastItemEvent: Mutation['removeLastItemEvent'] }
type TVariables = MutationRemoveLastItemEventArgs

export function useRemoveLastItemEvent(
  opts: MutationHookOptions<TData, TVariables> = {},
) {
  const [removeLastItemEvent] = useMutation<TData, TVariables>(
    REMOVE_LAST_ITE_EVENT,
    opts,
  )

  return removeLastItemEvent
}
